import { createContext, useContext, useEffect, useState } from "react";

const STRINGS = {
  en: {
    nav: { home: "Home", about: "About", services: "Services", listings: "Marketplace", aiTools: "AI Tools", blog: "Insights", faq: "FAQ", contact: "Contact", dashboard: "Dashboard" },
    hero: {
      eyebrow: "Africa & Middle East · Private Markets",
      title1: "Most Good Businesses Die",
      title2: "Before They Become",
      title3: "Great Businesses.",
      sub: "Not because they lack potential. But because they run out of funding, buyers, partners, or opportunities. DealVest connects business owners with investors, buyers, and strategic partners across Africa and the Middle East.",
      buyBtn: "Buy a Business",
      sellBtn: "Sell a Business",
      raiseBtn: "Raise Capital",
    },
    common: { learnMore: "Learn More", browse: "Browse Opportunities", viewAll: "View All", joinWaitlist: "Join Waitlist", submit: "Submit", askingPrice: "Asking Price", revenue: "Revenue", profit: "Profit", employees: "Employees", years: "Years Operating", country: "Country", industry: "Industry", verified: "Verified" },
    sections: { howItWorks: "How It Works", categories: "Featured Categories", whyDealvest: "Why DealVest", numbers: "By The Numbers", whoFor: "Who Is It For", waitlist: "Join The Future Of Business Transactions" },
  },
  ar: {
    nav: { home: "الرئيسية", about: "من نحن", services: "الخدمات", listings: "السوق", aiTools: "أدوات الذكاء", blog: "الرؤى", faq: "الأسئلة", contact: "اتصل بنا", dashboard: "لوحة التحكم" },
    hero: {
      eyebrow: "أفريقيا والشرق الأوسط · الأسواق الخاصة",
      title1: "معظم الشركات الجيدة تموت",
      title2: "قبل أن تصبح",
      title3: "شركات عظيمة.",
      sub: "ليس لأنها تفتقر إلى الإمكانات. بل لأنها تنفد من التمويل والمشترين والشركاء والفرص. تربط DealVest أصحاب الأعمال بالمستثمرين والمشترين والشركاء الاستراتيجيين عبر أفريقيا والشرق الأوسط.",
      buyBtn: "شراء شركة",
      sellBtn: "بيع شركة",
      raiseBtn: "جمع رأس المال",
    },
    common: { learnMore: "اعرف المزيد", browse: "تصفح الفرص", viewAll: "عرض الكل", joinWaitlist: "انضم لقائمة الانتظار", submit: "إرسال", askingPrice: "السعر المطلوب", revenue: "الإيرادات", profit: "الأرباح", employees: "الموظفون", years: "سنوات التشغيل", country: "الدولة", industry: "الصناعة", verified: "موثق" },
    sections: { howItWorks: "كيف يعمل", categories: "الفئات المميزة", whyDealvest: "لماذا DealVest", numbers: "بالأرقام", whoFor: "لمن هذا", waitlist: "انضم إلى مستقبل المعاملات التجارية" },
  },
  fr: {
    nav: { home: "Accueil", about: "À propos", services: "Services", listings: "Marché", aiTools: "Outils IA", blog: "Insights", faq: "FAQ", contact: "Contact", dashboard: "Tableau" },
    hero: {
      eyebrow: "Afrique & Moyen-Orient · Marchés privés",
      title1: "La plupart des bonnes entreprises meurent",
      title2: "avant de devenir",
      title3: "de grandes entreprises.",
      sub: "Non par manque de potentiel, mais par manque de financement, d'acheteurs, de partenaires ou d'opportunités. DealVest connecte les propriétaires d'entreprises aux investisseurs, acheteurs et partenaires stratégiques en Afrique et au Moyen-Orient.",
      buyBtn: "Acheter une entreprise",
      sellBtn: "Vendre une entreprise",
      raiseBtn: "Lever des fonds",
    },
    common: { learnMore: "En savoir plus", browse: "Parcourir les opportunités", viewAll: "Tout voir", joinWaitlist: "Rejoindre la liste", submit: "Envoyer", askingPrice: "Prix demandé", revenue: "Chiffre d'affaires", profit: "Bénéfice", employees: "Employés", years: "Années d'activité", country: "Pays", industry: "Industrie", verified: "Vérifié" },
    sections: { howItWorks: "Comment ça marche", categories: "Catégories", whyDealvest: "Pourquoi DealVest", numbers: "En chiffres", whoFor: "Pour qui", waitlist: "Rejoignez l'avenir des transactions d'affaires" },
  },
};

const I18nContext = createContext({ lang: "en", t: STRINGS.en, setLang: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("dv_lang") || "en");

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("dv_lang", l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, t: STRINGS[lang], setLang }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
